module.exports = __webpack_public_path__ + "media/images/landing_page/majaslapa-programma-4108505936de3d795798610e80dd7be3.png";